import React from "react";
import { useAppData } from "@danishagro/shared/src/contexts/appData.context";
import { useBottomSheet } from "../../../../../contexts/bottomSheet/bottomSheet.context";
import { useTranslations } from "../../../../../contexts/translations/translations.context";
import { DA_MiniSearch } from "../../MiniSearch/MiniSearch.component";
import { useSiteHeader } from "../../../../../contexts/siteHeader.context";
import { DA_MiniSearchB2c } from "../../MiniSearchB2c/MiniSearchB2c.component";

export const useSearchButton = () => {
    const { getDictionaryString } = useTranslations();
    const { closeMobileNav, showMobileNav } = useSiteHeader();
    const { currentSite } = useAppData();

    const { presentBottomSheet, dismissBottomSheet, activeBottomSheet } = useBottomSheet();

    const b2cSite = currentSite === "B2C";

    const onSearchButtonClicked = () => {
        const id = "search";

        if (activeBottomSheet !== id) {
            presentBottomSheet(b2cSite ? <DA_MiniSearchB2c /> : <DA_MiniSearch />, {
                id: id,
                headerTitle: getDictionaryString("searchModalTitle"),
            });
            // Close mobileNav after bottomSheet has opened
            if (showMobileNav) {
                setTimeout(() => {
                    closeMobileNav();
                }, 500);
            }
        } else {
            dismissBottomSheet();
        }
    };

    return {
        showSearch: true,
        onSearchButtonClicked,
        isSearchMenuActive: false,
    };
};
